import { Component } from "react"
import PropTypes from "prop-types"

import ConnectButton from "./connect_button"

export default class ConnectedApplet extends Component {
  render() {
    return (
      <ConnectButton
        connectButtonMaxFontSize={this.props.connectButtonMaxFontSize}
        connectClicked={this.props.connectClicked}
        connected={this.props.appletConnected}
        ctaCopy="Connected"
        knobBgColorForDarkBrands={this.props.knobBgColorForDarkBrands}
        mainService={this.props.mainService}
        onConnectClick={this.props.onDisconnectClick}
        programmable={this.props.programmable}
        userDevice={this.props.userDevice}
        showKnob
      />
    )
  }
}

ConnectedApplet.propTypes = {
  appletConnected: PropTypes.bool,
  connectButtonMaxFontSize: PropTypes.number,
  connectClicked: PropTypes.bool.isRequired,
  knobBgColorForDarkBrands: PropTypes.bool,
  mainService: PropTypes.object.isRequired,
  onDisconnectClick: PropTypes.func.isRequired,
  programmable: PropTypes.bool,
  userDevice: PropTypes.string,
}
